import { SPOILER_TYPE } from "../types.js";
const initSpoilersContentState = (contentState) => {
  let prevSpoilerStyle = "";
  const blocks = contentState.blocks.map((block) => {
    let isBlockContainSpoiler;
    const inlineStyleRanges = block?.inlineStyleRanges?.map((range) => {
      if (range.style === SPOILER_TYPE) {
        isBlockContainSpoiler = true;
        if (block.text.length === range.offset + range.length) {
          prevSpoilerStyle = range.offset !== 0 || prevSpoilerStyle === "" ? `SPOILER_${block.key}_${range.offset}_${range.offset + range.length}` : prevSpoilerStyle;
        }
        return {
          ...range,
          style: range.offset === 0 && prevSpoilerStyle !== "" ? prevSpoilerStyle : `SPOILER_${block.key}_${range.offset}_${range.offset + range.length}`
        };
      }
      return { ...range };
    });
    if (!isBlockContainSpoiler) {
      prevSpoilerStyle = "";
    }
    return {
      ...block,
      inlineStyleRanges
    };
  });
  return {
    ...contentState,
    blocks
  };
};
export {
  initSpoilersContentState
};
//# sourceMappingURL=spoiler-utils-fn.js.map
